import { NgModule } from '@angular/core';
import { DependenciesModule } from '../dependencies.module';
import { AdminDetailModule } from './admin-detail.module';
import { AdminRoutingModule } from './admin-routing.module';


// import { IdentityDetailModule } from '../laas/identity/identity-detail.module';

import { AdminComponent } from './admin.component';
import { SettingComponent } from './setting/setting.component';
import { ViewLandRecordUpdatationComponent, LoaderDialogComponent } from './view-landrecordupdatation/view-landrecordupdatation.component';
import { ViewCoapplicantsComponent } from './view-coapplicants/view-coapplicants.component';
import { AddCoapplicantComponent } from './add-coapplicant/add-coapplicant.component';
import { ViewGuarantorComponent } from './view-guarantor/view-guarantor.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ViewDashboardComponent, LoaderDialogDashComponent } from './view-dashboard/view-dashboard.component';
import { ViewMisComponent, LoaderDialogOnlineComponent } from './view-mis/view-mis.component';
import { LoaderDialogOfflineComponent, ViewOfflineComponent } from './view-leadbox/lead-box.component';
import { LoaderDialogConsentComponent, ViewConsentComponent } from './view-consent/view-consent.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ViewCustomerSubmittedComponent } from './view-customer-submitted/view-customer-submitted.component';
import { PopupComponent, ViewCbsApprovedComponent } from './view-cbs-approved/view-cbs-approved.component';
import { ManageAdminsComponent } from './manage-admins/manage-admins.component';
import { AddUserComponent } from './add-user/add-user.component';
import { LoaderDialogConsentComponent1, RenewalInboxComponent } from './renewal-inbox/renewal-inbox.component';
import { ViewUtilitiesComponent } from './view-utilities/view-utilities.component';
import { Landing1Component } from './landing1/landing1.component';
import { OpenDialogYesOrNo } from 'app/laas/dialog-yes-or-no/dialog-yes-or-no.component';
import { OpenAdminDialogYesOrNo } from './admin-yes-or-no/admin-yes-or-no.component';
import { ReconciliationReportsComponent } from '../fresh-app/reconciliation-reports/reconciliation-reports.component';
import { ScaleOfFinanceComponent } from './scale-of-finance/scale-of-finance.component';
import { StaleUsersReportComponent } from './stale-users-report/stale-users-report.component';
import { MatLegacyCardModule } from '@angular/material/legacy-card';
import { MatLegacyFormField, MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatLegacySlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyTabsModule } from '@angular/material/legacy-tabs';


@NgModule({
  imports: [
    DependenciesModule,
    AdminDetailModule,
    AdminRoutingModule,
    // IdentityDetailModule,
    ModalModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    MatLegacyTabsModule,
    MatIconModule,
    MatLegacyCardModule,
    MatLegacyMenuModule,
    MatSidenavModule,
    MatLegacySelectModule,
    MatLegacySlideToggleModule,
    MatLegacyProgressBarModule,
    MatLegacyInputModule,
    MatLegacyFormFieldModule


  ],
  declarations: [
    AdminComponent,
    SettingComponent,
    ViewLandRecordUpdatationComponent,
    ViewDashboardComponent,
    LoaderDialogOnlineComponent,
    LoaderDialogOfflineComponent,
    LoaderDialogConsentComponent,
    LoaderDialogConsentComponent1,
    LoaderDialogComponent,
    LoaderDialogDashComponent,
    ViewMisComponent,
    ViewConsentComponent,
    ViewOfflineComponent,
    ViewCoapplicantsComponent,
    AddCoapplicantComponent,
    ViewGuarantorComponent,
    LoaderDialogComponent,
    ViewCustomerSubmittedComponent,
    ViewCbsApprovedComponent ,
    PopupComponent,
    ManageAdminsComponent,
    AddUserComponent,
    RenewalInboxComponent,
    ViewUtilitiesComponent,
    Landing1Component, OpenAdminDialogYesOrNo, ScaleOfFinanceComponent, StaleUsersReportComponent
  ],
  // AddCoapplicantComponent
  exports: [ViewMisComponent, StaleUsersReportComponent],
})
export class AdminModule { }
